import { ActionState, ActionStateEnum } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { ArrangementGroup, ArrangementObject, Commands, ComponentConstants, Entity, Events, eventsManager, GeometryPrimitive, Joinery, joineryManager, math, RenderCamera, roomManager, SavaneConstants, SceneConstants, Staircase, TechnicalElement, TemplateImage, wallManager } from "@rhinov/savane-js";

declare var cc: any;

export class IdleEditState extends ActionState {

    state: number = ActionStateEnum.idleEdit;
    ctrlPressed: boolean = false;
    bPressed: boolean = false;
    vPressed: boolean = false;
    selectedItem: Entity | null = null;
    selectedItems: Entity[] = [];

    constructor() {
        super();
    }

    getAction(): number {
        return ActionStateEnum.idleEdit;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        GameObjectManager.updateSafeZone(cursorPosition);
        return null;
    }


    actionEditEntity(selected: any) {
        var i, j;
        var joinChild, position;
        var notValid = selected.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);

        //TODO : move this at the right pos (could be refacto considering there is 3 time the "set local position" block)
        // Twice here and one in sliderButtonHandler method  of file IdleConstruction
        if (notValid) {
            if (selected.entityType === SceneConstants.EntityType.Wall) {
                for (i = 0; i < selected.children.length; i++) {
                    var join = selected.children[i];
                    if (join.entityType === SceneConstants.EntityType.Joinery) {
                        for (j = 0; j < join.children.length; j++) {
                            joinChild = join.children[j];
                            if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                                joinChild.objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                                joinChild.ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {

                                joinChild.length = join.length;
                                position = math.vec3.create();
                                //if (joinChild.transform.localPosition[1] < 0) {
                                if (join.orientation) {
                                    math.vec3.set(position, 0, -selected.thickness / 2, join.height + join.floorHeight);
                                } else {
                                    math.vec3.set(position, 0, selected.thickness / 2, join.height + join.floorHeight);
                                }
                                if (join.transom) {
                                    position[2] = join.transomHeight;
                                }
                                joinChild.transform.localPosition = position;
                            }
                        }
                    }
                }
            } else if (selected.entityType === SceneConstants.EntityType.Joinery) {
                for (j = 0; j < selected.children.length; j++) {
                    joinChild = selected.children[j];
                    if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                        joinChild.objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                        joinChild.ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                        joinChild.length = selected.length;
                        position = math.vec3.create();
                        if (joinChild.transform.localPosition[1] < 0) {
                            math.vec3.set(position, 0, -selected.parent.thickness / 2, selected.height + selected.floorHeight);
                        } else {
                            math.vec3.set(position, 0, selected.parent.thickness / 2, selected.height + selected.floorHeight);
                        }
                        if (selected.transom) {
                            position[2] = selected.transomHeight;
                        }
                        joinChild.transform.localPosition = position;
                    }
                }
            }
            else if (selected.entityType === SceneConstants.EntityType.ArrangementObject ||
                selected.entityType === SceneConstants.EntityType.ArrangementGroup) {
                selected.updateFloorHeightFromAnchor(roomManager.getRoomAtPosition(selected.position, PlanManager.getInstance().world.currentScene!.currentFloor!), PlanManager.getInstance().world.currentScene!.currentFloor!);

                PlanManager.getInstance().executeCommand(new Commands.EditEntityCommand(selected));
            }
            else if (selected.isRenderCameraEntity()) {
                PlanManager.getInstance().executeCommand(new Commands.EditRenderCameraCommand(selected, false as any));
            }
            else if (selected.isCommentEntity()) {
                PlanManager.getInstance().executeCommand(new Commands.EditCommentCommand(selected));
            }
        }
        if (selected.isWallEntity()) {
            var beginWalls = wallManager.getWallsAtCorner(selected.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
            if (beginWalls != null) {
                for (i = 0; i < beginWalls.length; ++i) {
                    GameObjectManager.drawWall(beginWalls[i], notValid, false);
                }
            }
            var endWalls = wallManager.getWallsAtCorner(selected.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
            if (endWalls != null) {
                for (i = 0; i < endWalls.length; ++i) {
                    GameObjectManager.drawWall(endWalls[i], notValid, false);
                }
            }
            GameObjectManager.drawWall(selected, notValid, true);
        } else {
            var node = EntityManager.getInstance().getNode(selected);
            if (node !== null) {
                node.update(undefined);
            }
        }
        eventsManager.instance.dispatch(Events.ACTIONS_COUNT_CHANGE);
        eventsManager.instance.dispatch(Events.SHOW_WALL_PROPERTIES, { obj: selected });
    }

    // Moves the selection by a vector x, y, z
    moveSelectedObjects(x: number, y: number, z: number) {
        // Parse all selected items
        for (var i = 0; i < this.selectedItems.length; i++) {
            if (this.selectedItems[i].isStaircaseEntity() || this.selectedItems[i].isTechnicalElementEntity() || this.selectedItems[i].isGeometryPrimitiveEntity()) {
                if (this.isDecorationState()) {
                    continue;
                }
            }
            else {
                if (!this.isDecorationState()) {
                    continue;
                }
            }
            let entity = this.selectedItems[i];

            // If it is a stairway, technical element, arrangement object or group (all entities that are managed by entities and not dedicated entities)
            if ((entity instanceof Staircase || entity instanceof TechnicalElement || entity instanceof ArrangementObject ||
                entity instanceof ArrangementGroup || entity instanceof RenderCamera ||
                entity instanceof Comment || entity instanceof GeometryPrimitive)) {
                // The item is temprorary now
                this.selectedItems[i].startTemporary();
                // Get its position
                var curPosition = this.selectedItems[i].position;
                // Translate the object by x, y and z
                curPosition[0] += x;
                // Warning for arrangements, lights and cameras Y<->Z
                if (this.selectedItems[i].isArrangementObjectEntity() || this.selectedItems[i].isArrangementGroupEntity() || this.selectedItems[i].isRenderCameraEntity() || this.selectedItems[i].isCommentEntity()) {
                    if (y !== 0) {
                        if (this.selectedItems[i].isArrangementObjectEntity() || this.selectedItems[i].isArrangementGroupEntity()) {
                            (this.selectedItems[i] as ArrangementGroup).isAnchorActive = false;
                        }
                    }
                    curPosition[2] += y;
                    curPosition[1] += z;
                }
                else {
                    curPosition[1] += y;
                    curPosition[2] += z;
                }
                // Reassign position
                this.selectedItems[i].position = curPosition;

                // Check if the new position is valid
                if (entity.temporary) {
                    entity.temporary.recomputeValidity = true;
                }
                if (!this.selectedItems[i].isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                    // If not the object goes back to its position, simply free the temporary of it
                    this.selectedItems[i].endTemporary();
                }
                else {
                    // Otherwise create a command to move it
                    //this.actionEditEntity(this.selectedItems[i]);
                    if (entity instanceof ArrangementObject || entity instanceof ArrangementGroup) {
                        const room = roomManager.getRoomAtPosition(this.selectedItems[i].position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                        if (room) {
                            entity.updateFloorHeightFromAnchor(room, PlanManager.getInstance().world.currentScene!.currentFloor!);
                        }
                    }
                }
            }
        }

        PlanManager.getInstance().executeCommand(new Commands.EditEntitiesCommand(this.selectedItems));

        // At the end re-select the objects since the command will have selected only the final last element
        PlanManager.getInstance().updateItemsSelected(this.selectedItems, false, false);
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean): ActionState | null {
        if (keyCode == cc.KEY.ctrl) {
            this.ctrlPressed = false;
        }

        if (keyCode === cc.KEY.v) {
            this.vPressed = false;
        }
        if (keyCode === cc.KEY.b) {
            this.bPressed = false;
        }

        if (keyCode === cc.KEY.m) {
            GameObjectManager.deleteMeasure();
        }
        if (keyCode === cc.KEY.t) {
            GameObjectManager.deleteSafeZone();
        }

        return null;
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        this.selectedItem = PlanManager.getInstance().selectedEntities[0];
        this.selectedItems = PlanManager.getInstance().selectedEntities;

        if (this.selectedItem === undefined) {
            this.selectedItem = null;
        }

        var direction, prevPosition, curPosition, moveDist;

        if (keyCode == cc.KEY.ctrl) {
            this.ctrlPressed = true;
        }

        if (keyCode === cc.KEY.s) {
            PlanManager.getInstance().toggleSnap();
        }

        if (keyCode === cc.KEY.v) {
            this.vPressed = true;
        }
        if (keyCode === cc.KEY.b) {
            this.bPressed = true;
        }

        if (keyCode === cc.KEY.m && this.selectedItems.length === 0) {
            GameObjectManager.drawMeasure();
        }
        if (keyCode === cc.KEY.t) {
            GameObjectManager.drawSafeZone();
        }

        if (this.selectedItem !== null && this.selectedItem instanceof Joinery && this.selectedItem.wall != null && !this.isDecorationState()) {
            if (keyCode == cc.KEY.up) {
                //Retrieve wall direction
                direction = this.selectedItem.wall.wallDirection;
                if (this.selectedItem.joineryType === SceneConstants.JoineryType.velux) {
                    var line = new (math as any).Line(this.selectedItem.wall.begin, this.selectedItem.wall.end);
                    var projection = line.Project(this.selectedItem.position);
                    projection[2] = this.selectedItem.position[2];
                    direction = math.vec3.create();
                    math.vec3.subtract(direction, this.selectedItem.position, projection);
                    math.vec3.normalize(direction, direction);
                }
                prevPosition = this.selectedItem.position;
                curPosition = this.selectedItem.position;
                if (direction[1] > 0) {
                    moveDist = math.vec3.create();
                    moveDist[0] = 10 * direction[0];
                    moveDist[1] = 10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                } else if (direction[1] < 0) {
                    moveDist = math.vec3.create();
                    moveDist[0] = -10 * direction[0];
                    moveDist[1] = -10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                }
                if (!joineryManager.isJoineryValid(this.selectedItem)) {
                    this.selectedItem.position = prevPosition;
                }
            }
            if (keyCode == cc.KEY.down) {
                //Retrieve wall direction
                direction = this.selectedItem.wall.wallDirection;
                if (this.selectedItem.joineryType === SceneConstants.JoineryType.velux) {
                    var line = new (math as any).Line(this.selectedItem.wall.begin, this.selectedItem.wall.end);
                    var projection = line.Project(this.selectedItem.position);
                    projection[2] = this.selectedItem.position[2];
                    direction = math.vec3.create();
                    math.vec3.subtract(direction, this.selectedItem.position, projection);
                    math.vec3.normalize(direction, direction);
                }
                prevPosition = this.selectedItem.position;
                curPosition = this.selectedItem.position;
                if (direction[1] < -0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = 10 * direction[0];
                    moveDist[1] = 10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                } else if (direction[1] > 0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = -10 * direction[0];
                    moveDist[1] = -10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                }
                if (!joineryManager.isJoineryValid(this.selectedItem)) {
                    this.selectedItem.position = prevPosition;
                }
            }
            if (keyCode == cc.KEY.left) {
                //Retrieve wall direction
                direction = this.selectedItem.wall.wallDirection;
                prevPosition = this.selectedItem.position;
                curPosition = this.selectedItem.position;
                if (direction[0] < -0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = 10 * direction[0];
                    moveDist[1] = 10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                } else if (direction[0] > 0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = -10 * direction[0];
                    moveDist[1] = -10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                }
                if (!joineryManager.isJoineryValid(this.selectedItem)) {
                    this.selectedItem.position = prevPosition;
                }
            }
            if (keyCode == cc.KEY.right) {
                //Retrieve wall direction
                direction = this.selectedItem.wall.wallDirection;
                prevPosition = this.selectedItem.position;
                curPosition = this.selectedItem.position;
                if (direction[0] > 0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = 10 * direction[0];
                    moveDist[1] = 10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                } else if (direction[0] < -0.0001) {
                    moveDist = math.vec3.create();
                    moveDist[0] = -10 * direction[0];
                    moveDist[1] = -10 * direction[1];
                    math.vec3.add(curPosition, curPosition, moveDist);
                    this.selectedItem.position = curPosition;
                }
                if (!joineryManager.isJoineryValid(this.selectedItem)) {
                    this.selectedItem.position = prevPosition;
                }
            }
        }
        else if (this.selectedItem !== null && (this.selectedItem.isStaircaseEntity()
            || this.selectedItem.isTechnicalElementEntity()
            || this.selectedItem.isArrangementObjectEntity()
            || this.selectedItem.isArrangementGroupEntity()
            || this.selectedItem.isRenderCameraEntity()
            || this.selectedItem.isCommentEntity()
            || this.selectedItem.isGeometryPrimitiveEntity())) {

            if (!this.bPressed && !this.vPressed) {
                if (keyCode == cc.KEY.down) {
                    this.moveSelectedObjects(0, -10, 0);
                }
                if (keyCode == cc.KEY.up) {
                    this.moveSelectedObjects(0, 10, 0);
                }
                if (keyCode == cc.KEY.left) {
                    this.moveSelectedObjects(-10, 0, 0);
                }
                if (keyCode == cc.KEY.right) {
                    this.moveSelectedObjects(10, 0, 0);
                }
                if (keyCode == cc.KEY.pagedown) {
                    this.moveSelectedObjects(0, 0, -10);
                }
                if (keyCode == cc.KEY.pageup) {
                    this.moveSelectedObjects(0, 0, 10);
                }
            }
        } else {
            //TODO Move background plan using arrow keys
            var backPlan = PlanManager.getInstance().world.currentScene!.currentFloor!.getComponent(ComponentConstants.ComponentType.TemplateImage) as TemplateImage;
            if (backPlan !== null) {
                var offset = GameObjectManager.convertToCocosCoord(backPlan.offset);
                var offsetValue = 1;

                if (this.ctrlPressed) {
                    offsetValue = 10;
                }

                if (keyCode == cc.KEY.up) {
                    offset.y += offsetValue;
                }
                if (keyCode == cc.KEY.down) {
                    offset.y -= offsetValue;
                }
                if (keyCode == cc.KEY.right) {
                    offset.x += offsetValue;
                }
                if (keyCode == cc.KEY.left) {
                    offset.x -= offsetValue;
                }
                if (keyCode == 107) {
                    backPlan.userScale = GameObjectManager.getScaleUserMap() + 0.01;
                    GameObjectManager.scaleUserMap(GameObjectManager.getScaleUserMap() + 0.01);
                }
                if (keyCode == 109) {
                    backPlan.userScale = GameObjectManager.getScaleUserMap() - 0.01;
                    GameObjectManager.scaleUserMap(GameObjectManager.getScaleUserMap() - 0.01);
                }
                //Apply to node
                GameObjectManager.offsetUserMap(offset);
                backPlan.offset = GameObjectManager.retrieveFromCocosCoord(offset);
            }
        }
        return null;
    }
}
